import { Reducer, useReducer } from 'react';

export type TMediaUploadState = {
  fileRows: {
    status: 'selected' | 'uploading' | 'completed' | 'failed';
    file: File;
    progress: number;
    url?: string;
    error?: Error;
  }[];
};

export type TMediaUploadAction =
  | { type: 'init'; fileList: FileList | File[] }
  | { type: 'start'; file: File }
  | { type: 'reset' }
  | { type: 'cancel'; file: File }
  | { type: 'progress'; file: File; progress: number }
  | { type: 'complete'; file: File; url?: string }
  | { type: 'fail'; file: File; error?: Error };

const defaultState = { fileRows: [] };

const reducer: Reducer<TMediaUploadState, TMediaUploadAction> = (prevState, action) => {
  switch (action.type) {
    case 'init':
      return {
        fileRows: Array.from(action.fileList).map((file) => ({
          file,
          status: 'selected',
          progress: 0,
        })),
      };
    case 'start':
      return {
        fileRows: prevState.fileRows.map((prev) =>
          prev.file === action.file ? { ...prev, status: 'selected', progress: 0 } : prev
        ),
      };
    case 'reset':
      return defaultState;
    case 'cancel':
      return { fileRows: prevState.fileRows.filter((prev) => prev.file !== action.file) };
    case 'progress':
      return {
        fileRows: prevState.fileRows.map((prev) =>
          prev.file === action.file
            ? { ...prev, progress: action.progress, status: 'uploading' }
            : prev
        ),
      };
    case 'complete':
      return {
        fileRows: prevState.fileRows.map((prev) =>
          prev.file === action.file ? { ...prev, status: 'completed', url: action.url } : prev
        ),
      };
    case 'fail':
      return {
        fileRows: prevState.fileRows.map((prev) =>
          prev.file === action.file ? { ...prev, status: 'failed', error: action.error } : prev
        ),
      };
  }
  return prevState;
};

export const useMediaUploadReducer = () => {
  const x = useReducer(reducer, defaultState);
  return x;
};

export default reducer;
